import { render, staticRenderFns } from "./m-deep-badge-crimson.vue?vue&type=template&id=3f0df330&scoped=true&"
import script from "./m-deep-badge-crimson.vue?vue&type=script&setup=true&lang=ts&"
export * from "./m-deep-badge-crimson.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./m-deep-badge-crimson.vue?vue&type=style&index=0&id=3f0df330&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0df330",
  null
  
)

export default component.exports